import React from 'react';
import { CTAButton } from './CTAButton';
import { pricing } from '../data/pricing';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-white scroll-mt-8" data-id="element-105" data-mp="19jxar7jxmx8p">
      <div className="max-w-3xl mx-auto text-center" data-id="element-106" data-mp="1ehyuzvt3h2lr">
        <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-14" data-id="element-107" data-mp="1eg5qam21ksge">
          Oferta Especial de Lanzamiento
        </h2>

        <div className="bg-white rounded-[2rem] border-2 border-brand-green p-8 md:p-12 shadow-xl relative max-w-xl mx-auto" data-id="element-108" data-mp="1nb24xu4j6xbn">
          <p className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-green text-white px-6 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase whitespace-nowrap" data-id="element-109" data-mp="1s8c3q0dt8lc5">
            Contenido del kit
          </p>

          <dl className="space-y-4 mb-8 text-left" data-id="element-110" data-mp="225gqo2fhcku0">
            {pricing.lineItems.map(item => <div key={item.label} className="flex justify-between items-center gap-6 border-b border-brand-creamDark pb-4" data-id="element-111" data-mp="2x1v9btj7kno">
                <dt className="text-brand-text font-medium" data-id="element-112" data-mp="1mhzgt6bke99c">{item.label}</dt>
                <dd className="text-brand-terracotta font-medium" data-id="element-113" data-mp="1hp6cuknx74yb">
                  {item.price}
                </dd>
              </div>)}
            <div className="flex justify-between items-center gap-6 pt-2" data-id="element-114" data-mp="17rsa1nux6eoh">
              <dt className="font-bold text-brand-text" data-id="element-115" data-mp="17pp8q7obgz4g">VALOR TOTAL:</dt>
              <dd className="font-bold text-brand-terracotta" data-id="element-116" data-mp="25e7rwqr9deck">
                {pricing.fullValue}
              </dd>
            </div>
          </dl>

          <div className="text-center mb-8" data-id="element-117" data-mp="1vhcr217ij1v4">
            <p className="text-5xl md:text-6xl font-black text-brand-green tracking-tight mb-1" data-id="element-118" data-mp="1vg1ou5tpu264">
              {pricing.price}
            </p>
            <p className="text-sm font-bold uppercase tracking-widest text-brand-green/70 mb-3" data-id="element-119" data-mp="1ri3xoxgdx603">
              {pricing.currencyNote}
            </p>
            <p className="text-brand-gray line-through font-medium text-lg mb-2" data-id="element-120" data-mp="fzjcegndfgab">
              {pricing.fullValue}
            </p>
            <p className="text-sm text-brand-gray font-medium" data-id="element-121" data-mp="hfotvnyy1u6a">
              Con tarjeta o Mercado Pago &middot; hasta 3 cuotas sin interés
            </p>
          </div>

          <CTAButton href="https://yoga-listo.impultienda.ar/checkout" className="w-full mb-6 text-base md:text-lg py-5" data-id="element-122" data-mp="7isk7exb7205">
            Quiero el Kit Yoga Lista
          </CTAButton>

          <p className="text-xs text-brand-gray font-medium" data-id="element-123" data-mp="3uvd0w5951t7v">
            Descarga inmediata &middot; Pago único &middot; Acceso de por vida
            &middot; 7 días de garantía
          </p>
          <p className="mt-2 text-xs text-brand-gray" data-id="element-124" data-mp="3l01i9bum01uu">
            Precio final en pesos. No genera suscripción ni cobros futuros.
          </p>
        </div>
      </div>
    </section>;
}